// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3kabw","tab":"Tabs_tab__h6Yea","tabActive":"Tabs_tabActive__2Tf9j"};